import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Header from "../../directives/header";
import Footer from "../../directives/footer";
import Sidebar from "../../directives/sidebar";
import { getUserById } from "../../Action/action";
import toast, { Toaster } from "react-hot-toast";
import { MdKeyboardBackspace, MdEmail, MdPhone, MdVerifiedUser, MdAccountBalance } from "react-icons/md";
import { FaUser, FaMapMarkerAlt, FaCity, FaRegAddressBook } from "react-icons/fa";
import config from "../../coreFIles/config";
import { Col, Row } from "react-bootstrap";
import { IoIosCodeWorking } from "react-icons/io";
import { Si2Fas } from "react-icons/si";
import { FaCircleExclamation } from "react-icons/fa6";

const ViewUsers = () => {
  const { id } = useParams();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const res = await getUserById(id);
        console.log(res,"res")
        if (res.status) {
          setUser(res.data);
        } else {
          toast.error(res.msg);
        }
      } catch (err) {
        toast.error("Failed to fetch user");
      } finally {
        setLoading(false);
      }
    };
    fetchUser();
  }, [id]);

  if (loading) {
    return <div className="text-center py-5">Loading...</div>;
  }

  if (!user) return null;
  const handleCopy = (text, label) => {
    navigator.clipboard.writeText(text);
    toast.success(`${label} copied!`);
  };

  return (
    <div className="wrapper">
      <Header />
      <Sidebar />
      <Toaster />

      <div className="content-wrapper">
        <div className="container-full">
          <section className="content">

            <div className="box">
              <div className="box-header d-flex align-items-center">
                <Link to={`${config.baseUrl}userList`} className="me-3">
                  <MdKeyboardBackspace size={24} />
                </Link>
                <h4 className="mb-0 fw-bold">View User Details</h4>
              </div>

              <div className="box-body">


                <Row>
                  <Col md={12}>
                    {/* BASIC INFO */}
                    <Section title="Basic Information" />
                    <div className="row">
                      <Info label="Full Name" value={`${user.firstName} ${user.lastName}`} icon={<FaUser />} />
                      <Info label="Account Type" value={user.accountType} icon={<MdAccountBalance />} />
                      <Info label="Email" value={user.email} icon={<MdEmail />} />
                      <Info label="Phone" value={user.phone} icon={<MdPhone />} />
                    </div>
                    <Divider />
                  </Col>

                  <Col md={12}>
                    {/* ADDRESS */}
                    <Section title="Address" />
                    <div className="row">
                      <Info label="Country" value={user.country} icon={<FaMapMarkerAlt />} />
                      <Info label="City" value={user.city} icon={<FaCity />} />
                      <Info label="Postal Code" value={user.postalCode} icon={<IoIosCodeWorking />} />
                      <Info label="Full Address" value={user.address} full icon={<FaRegAddressBook />} />
                    </div>
                    <Divider />
                  </Col>

                  <Col md={12}>
                    {/* ACCOUNT STATUS */}
                    <Section title="Account Status" />
                    <div className="row">
                      <Info
                        label="KYC Verified"
                        value={user.isKycVerified ? "Yes" : "No"}
                        badge={user.isKycVerified ? "success" : "danger"}
                        icon={<MdVerifiedUser />}
                      />
                      <Info
                        label="2FA Enabled"
                        value={user.isTwoFAEnabled ? "Enabled" : "Disabled"}
                        badge={user.isTwoFAEnabled ? "success" : "secondary"}
                        icon={<Si2Fas />}
                      />
                      <Info
                        label="Account Status"
                        value={user.isBlock ? "Blocked" : "Active"}
                        badge={user.isBlock ? "danger" : "success"}
                        icon={<FaCircleExclamation />}
                      />
                      <Info
                        label="Wallet Address"
                        value={user?.walletAddress}
                        icon={<FaCircleExclamation />}
       
                      />
                                         <button
            className="btn btn-sm btn-outline-secondary"
            onClick={() => handleCopy(user?.walletAddress, "Wallet Address")}
          >
            <i className="fa fa-copy"></i>
          </button>
                    </div>
                    <Divider />
                  </Col>
                </Row>
              </div>
            </div>

          </section>
        </div>
      </div>

      <Footer />
    </div>
  );
};

/* ================== REUSABLE COMPONENTS ================== */

const Section = ({ title }) => (
  <h5 className="mb-3 fw-bold text-primary">{title}</h5>
);

const Divider = () => <hr className="my-2 mt-4" />;
// className={`col-md-${full ? 12 : 4} mb-3`}
const Info = ({ label, value, badge, full, icon }) => (
  <div className="">
    <Row className="my-2">
      <Col xs={6} md={6} lg={6} xl={5} className="pe-0">
        <div className="d-flex align-items-center">
          {icon && <span className="me-2 text-muted">{icon}</span>}
          <div className="fw-semibold d-flex">
            <span>{label}</span>
            <span>&ensp;:</span>
          </div>
        </div>
      </Col>

      <Col xs={6} md={6} lg={6} xl={7}>
        {badge ? (
          <>
            &ensp;
            <span className={`badge fw-bold text-${badge} p-0`} style={{fontSize:'13px'}}>
              {value}
            </span>
          </>
        ) : (
          <div className="fw-semibold">
            &ensp;{value || "-"}
          </div>
        )}
      </Col>
    </Row>
  </div>
);

export default ViewUsers;
